import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function AdviceIcon({ dropShadow, width, height, viewBox, style, className }: IIcon) {
    return (
        <Icon
            dropShadow={dropShadow}
            width={width}
            height={height}
            viewBox={viewBox ?? '0 0 24 24'}
            style={style}
            className={className}
        >
            <path
                d="M14.7342 1.6001H9.26595C5.03221 1.6001 1.6001 5.03221 1.6001 9.26595V14.7342C1.6001 18.968 5.03221 22.4001 9.26595 22.4001H14.7342C18.968 22.4001 22.4001 18.968 22.4001 14.7342V9.26595C22.4001 5.03221 18.968 1.6001 14.7342 1.6001ZM10.9567 7.10673C10.9828 6.96965 11.0364 6.83927 11.1143 6.72344C11.1535 6.6658 11.1977 6.61166 11.2463 6.5616C11.6704 6.16458 12.3298 6.16458 12.7539 6.5616C12.9515 6.76295 13.063 7.0333 13.0648 7.31541C13.0711 7.38483 13.0711 7.45468 13.0648 7.52409C13.0387 7.66118 12.9851 7.79155 12.9072 7.90739C12.8669 7.96421 12.8228 8.01827 12.7752 8.06922C12.3722 8.49745 11.6984 8.51792 11.2702 8.11495C11.0502 7.90798 10.9285 7.61735 10.9354 7.31541C10.9362 7.24535 10.9433 7.17551 10.9567 7.10673ZM13.3629 17.5365H10.6373C10.1669 17.5365 9.78552 17.1552 9.78552 16.6848C9.78552 16.2144 10.1669 15.833 10.6373 15.833H11.1483V11.1483H10.7225C10.252 11.1483 9.8707 10.767 9.8707 10.2966C9.8707 9.82616 10.252 9.44482 10.7225 9.44482H12.0001C12.4705 9.44482 12.8519 9.82616 12.8519 10.2966V15.833H13.3629C13.8333 15.833 14.2147 16.2144 14.2147 16.6848C14.2147 17.1552 13.8333 17.5365 13.3629 17.5365Z"
                fill="currentColor"
            />
        </Icon>
    );
}
